import type BaseEnumType from "@/app/services/baseEnumType";
import { EnumAccountPostingLineType } from "@/app/services/generated/enums/enumAccountPostingLineType.generated";
import { EnumAccountPostingStatus } from "@/app/services/generated/enums/enumAccountPostingStatus.generated";
import { EnumAccountsPackageType } from "@/app/services/generated/enums/enumAccountsPackageType.generated";
import { EnumActivityLogType } from "@/app/services/generated/enums/enumActivityLogType.generated";
import { EnumAddressLine } from "@/app/services/generated/enums/enumAddressLine.generated";
import { EnumAggregatingOperation } from "@/app/services/generated/enums/enumAggregatingOperation.generated";
import { EnumAiRequestType } from "@/app/services/generated/enums/enumAiRequestType.generated";
import { EnumAlcoholType } from "@/app/services/generated/enums/enumAlcoholType.generated";
import { EnumAnswerFormat } from "@/app/services/generated/enums/enumAnswerFormat.generated";
import { EnumAssemblyIngredientSource } from "@/app/services/generated/enums/enumAssemblyIngredientSource.generated";
import { EnumAssemblyOutputTarget } from "@/app/services/generated/enums/enumAssemblyOutputTarget.generated";
import { EnumAssemblyRecipeType } from "@/app/services/generated/enums/enumAssemblyRecipeType.generated";
import { EnumAssemblyStatus } from "@/app/services/generated/enums/enumAssemblyStatus.generated";
import { EnumAssemblyType } from "@/app/services/generated/enums/enumAssemblyType.generated";
import { EnumAustralianAlcoholTariff } from "@/app/services/generated/enums/enumAustralianAlcoholTariff.generated";
import { EnumBeerflexOrderConfirmationStatus } from "@/app/services/generated/enums/enumBeerflexOrderConfirmationStatus.generated";
import { EnumBeerflexOrderType } from "@/app/services/generated/enums/enumBeerflexOrderType.generated";
import { EnumBillingPlanStatus } from "@/app/services/generated/enums/enumBillingPlanStatus.generated";
import { EnumBmEntityType } from "@/app/services/generated/enums/enumBmEntityType.generated";
import { EnumBogofQuantityBasis } from "@/app/services/generated/enums/enumBogofQuantityBasis.generated";
import { EnumBottleDepositBalanceChangeReason } from "@/app/services/generated/enums/enumBottleDepositBalanceChangeReason.generated";
import { EnumBpSessionErrorReason } from "@/app/services/generated/enums/enumBpSessionErrorReason.generated";
import { EnumBrewmanBarcodeType } from "@/app/services/generated/enums/enumBrewmanBarcodeType.generated";
import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import { EnumCaseLabelWeightType } from "@/app/services/generated/enums/enumCaseLabelWeightType.generated";
import { EnumChangeLogLineType } from "@/app/services/generated/enums/enumChangeLogLineType.generated";
import { EnumChangeSection } from "@/app/services/generated/enums/enumChangeSection.generated";
import { EnumChangeType } from "@/app/services/generated/enums/enumChangeType.generated";
import { EnumColumnType } from "@/app/services/generated/enums/enumColumnType.generated";
import { EnumConsumableType } from "@/app/services/generated/enums/enumConsumableType.generated";
import { EnumContainerStatus } from "@/app/services/generated/enums/enumContainerStatus.generated";
import { EnumCostPriceUpdateType } from "@/app/services/generated/enums/enumCostPriceUpdateType.generated";
import { EnumCountry } from "@/app/services/generated/enums/enumCountry.generated";
import { EnumCreditCalculationType } from "@/app/services/generated/enums/enumCreditCalculationType.generated";
import { EnumCreditType } from "@/app/services/generated/enums/enumCreditType.generated";
import { EnumCtVirtualNo } from "@/app/services/generated/enums/enumCtVirtualNo.generated";
import { EnumCurrency } from "@/app/services/generated/enums/enumCurrency.generated";
import { EnumCustomerHappinessRating } from "@/app/services/generated/enums/enumCustomerHappinessRating.generated";
import { EnumDashboardComponent } from "@/app/services/generated/enums/enumDashboardComponent.generated";
import { EnumDataImportAction } from "@/app/services/generated/enums/enumDataImportAction.generated";
import { EnumDataImportDateFormat } from "@/app/services/generated/enums/enumDataImportDateFormat.generated";
import { EnumDataImportTimestampFormat } from "@/app/services/generated/enums/enumDataImportTimestampFormat.generated";
import { EnumDataImportType } from "@/app/services/generated/enums/enumDataImportType.generated";
import { EnumDateFormat } from "@/app/services/generated/enums/enumDateFormat.generated";
import { EnumDateType } from "@/app/services/generated/enums/enumDateType.generated";
import { EnumDayOfWeek } from "@/app/services/generated/enums/enumDayOfWeek.generated";
import { EnumDeliveryNotificationSetting } from "@/app/services/generated/enums/enumDeliveryNotificationSetting.generated";
import { EnumDiscountBasis } from "@/app/services/generated/enums/enumDiscountBasis.generated";
import { EnumDiscountParent } from "@/app/services/generated/enums/enumDiscountParent.generated";
import { EnumDiscountTierBasis } from "@/app/services/generated/enums/enumDiscountTierBasis.generated";
import { EnumDistributionType } from "@/app/services/generated/enums/enumDistributionType.generated";
import { EnumDocumentContextType } from "@/app/services/generated/enums/enumDocumentContextType.generated";
import { EnumDocumentEmailTag } from "@/app/services/generated/enums/enumDocumentEmailTag.generated";
import { EnumDocumentFileType } from "@/app/services/generated/enums/enumDocumentFileType.generated";
import { EnumDocumentGenerationOutputFileType } from "@/app/services/generated/enums/enumDocumentGenerationOutputFileType.generated";
import { EnumImageFormat } from "@/app/services/generated/enums/enumImageFormat.generated";
import { EnumDocumentTagType } from "@/app/services/generated/enums/enumDocumentTagType.generated";
import { EnumDocumentType } from "@/app/services/generated/enums/enumDocumentType.generated";
import { EnumDocumentTypeGroup } from "@/app/services/generated/enums/enumDocumentTypeGroup.generated";
import { EnumDutyHslsRate } from "@/app/services/generated/enums/enumDutyHslsRate.generated";
import { EnumDutyRateBasis } from "@/app/services/generated/enums/enumDutyRateBasis.generated";
import { EnumDutyScheme } from "@/app/services/generated/enums/enumDutyScheme.generated";
import { EnumDutySource } from "@/app/services/generated/enums/enumDutySource.generated";
import { EnumEcommerceConnectionStatus } from "@/app/services/generated/enums/enumEcommerceConnectionStatus.generated";
import { EnumEcommerceOrderOriginType } from "@/app/services/generated/enums/enumEcommerceOrderOriginType.generated";
import { EnumEdiSource } from "@/app/services/generated/enums/enumEdiSource.generated";
import { EnumEireAlcoholCategory } from "@/app/services/generated/enums/enumEireAlcoholCategory.generated";
import { EnumEireDutyRateBand } from "@/app/services/generated/enums/enumEireDutyRateBand.generated";
import { EnumEireMovementType } from "@/app/services/generated/enums/enumEireMovementType.generated";
import { EnumEmailContext } from "@/app/services/generated/enums/enumEmailContext.generated";
import { EnumEmailDocumentGrouping } from "@/app/services/generated/enums/enumEmailDocumentGrouping.generated";
import { EnumEmailTagSource } from "@/app/services/generated/enums/enumEmailTagSource.generated";
import { EnumEmailType } from "@/app/services/generated/enums/enumEmailType.generated";
import { EnumEprMaterialType } from "@/app/services/generated/enums/enumEprMaterialType.generated";
import { EnumEprPackagingActivity } from "@/app/services/generated/enums/enumEprPackagingActivity.generated";
import { EnumEprPackagingClass } from "@/app/services/generated/enums/enumEprPackagingClass.generated";
import { EnumEprPackagingType } from "@/app/services/generated/enums/enumEprPackagingType.generated";
import { EnumEprProducerStatus } from "@/app/services/generated/enums/enumEprProducerStatus.generated";
import { EnumEprRecyclabilityAssessmentRating } from "@/app/services/generated/enums/enumEprRecyclabilityAssessmentRating.generated";
import { EnumExportIncotermCode } from "@/app/services/generated/enums/enumExportIncotermCode.generated";
import { EnumExternalCalendarProvider } from "@/app/services/generated/enums/enumExternalCalendarProvider.generated";
import { EnumExternalOrderStatus } from "@/app/services/generated/enums/enumExternalOrderStatus.generated";
import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";
import { EnumFileType } from "@/app/services/generated/enums/enumFileType.generated";
import { EnumFilteringOperation } from "@/app/services/generated/enums/enumFilteringOperation.generated";
import { EnumGermanBeerDutyMovementType } from "@/app/services/generated/enums/enumGermanBeerDutyMovementType.generated";
import { EnumGermanBeerDutyProductType } from "@/app/services/generated/enums/enumGermanBeerDutyProductType.generated";
import { EnumGermanBeerDutyReturnCellProductType } from "@/app/services/generated/enums/enumGermanBeerDutyReturnCellProductType.generated";
import { EnumGetUserByCredentialStatus } from "@/app/services/generated/enums/enumGetUserByCredentialStatus.generated";
import { EnumGroupingOperation } from "@/app/services/generated/enums/enumGroupingOperation.generated";
import { EnumHistoryDateRangePick } from "@/app/services/generated/enums/enumHistoryDateRangePick.generated";
import { EnumIntegrationType } from "@/app/services/generated/enums/enumIntegrationType.generated";
import { EnumInvoicesOrCredits } from "@/app/services/generated/enums/enumInvoicesOrCredits.generated";
import { EnumItemMainPurpose } from "@/app/services/generated/enums/enumItemMainPurpose.generated";
import { EnumJourneyLabelStatus } from "@/app/services/generated/enums/enumJourneyLabelStatus.generated";
import { EnumJourneyStopPlanningStatus } from "@/app/services/generated/enums/enumJourneyStopPlanningStatus.generated";
import { EnumKegstarContainerType } from "@/app/services/generated/enums/enumKegstarContainerType.generated";
import { EnumLeadStatus } from "@/app/services/generated/enums/enumLeadStatus.generated";
import { EnumLocationBondedStatus } from "@/app/services/generated/enums/enumLocationBondedStatus.generated";
import { EnumMetricType } from "@/app/services/generated/enums/enumMetricType.generated";
import { EnumNatureOfTransactionCode } from "@/app/services/generated/enums/enumNatureOfTransactionCode.generated";
import { EnumEmailNotificationType } from "@/app/services/generated/enums/enumEmailNotificationType.generated";
import { EnumNumberingType } from "@/app/services/generated/enums/enumNumberingType.generated";
import { EnumOneFreePeriod } from "@/app/services/generated/enums/enumOneFreePeriod.generated";
import { EnumOrderSortBy } from "@/app/services/generated/enums/enumOrderSortBy.generated";
import { EnumOrderSource } from "@/app/services/generated/enums/enumOrderSource.generated";
import { EnumOrderStatus } from "@/app/services/generated/enums/enumOrderStatus.generated";
import { EnumOutletRatingExclusions } from "@/app/services/generated/enums/enumOutletRatingExclusions.generated";
import { EnumPackageTypeCategoryType } from "@/app/services/generated/enums/enumPackageTypeCategoryType.generated";
import { EnumPalletStatus } from "@/app/services/generated/enums/enumPalletStatus.generated";
import { EnumPlannedStockAction } from "@/app/services/generated/enums/enumPlannedStockAction.generated";
import { EnumPlannedStockFollowUpAction } from "@/app/services/generated/enums/enumPlannedStockFollowUpAction.generated";
import { EnumPlannedStockStatus } from "@/app/services/generated/enums/enumPlannedStockStatus.generated";
import { EnumPriceListGroupSortBy } from "@/app/services/generated/enums/enumPriceListGroupSortBy.generated";
import { EnumPriceListLineSortBy } from "@/app/services/generated/enums/enumPriceListLineSortBy.generated";
import { EnumPriceListSubGroup } from "@/app/services/generated/enums/enumPriceListSubGroup.generated";
import { EnumPrinterPreference } from "@/app/services/generated/enums/enumPrinterPreference.generated";
import { EnumProcessIngredientSource } from "@/app/services/generated/enums/enumProcessIngredientSource.generated";
import { EnumProcessOutputTarget } from "@/app/services/generated/enums/enumProcessOutputTarget.generated";
import { EnumPurchaseOrderDeliveryDisbursement } from "@/app/services/generated/enums/enumPurchaseOrderDeliveryDisbursement.generated";
import { EnumPurchaseOrderDeliveryStatus } from "@/app/services/generated/enums/enumPurchaseOrderDeliveryStatus.generated";
import { EnumPurchaseOrderStatus } from "@/app/services/generated/enums/enumPurchaseOrderStatus.generated";
import { EnumQcProbeProvider } from "@/app/services/generated/enums/enumQcProbeProvider.generated";
import { EnumQueuedJobType } from "@/app/services/generated/enums/enumQueuedJobType.generated";
import { EnumRecurringJobType } from "@/app/services/generated/enums/enumRecurringJobType.generated";
import { EnumReportBuilder } from "@/app/services/generated/enums/enumReportBuilder.generated";
import { EnumRetailPaymentMethod } from "@/app/services/generated/enums/enumRetailPaymentMethod.generated";
import { EnumSalesTextType } from "@/app/services/generated/enums/enumSalesTextType.generated";
import { EnumSalesVisitAssociatedEntityType } from "@/app/services/generated/enums/enumSalesVisitAssociatedEntityType.generated";
import { EnumScannerInputType } from "@/app/services/generated/enums/enumScannerInputType.generated";
import { EnumScannerType } from "@/app/services/generated/enums/enumScannerType.generated";
import { EnumSecurityProduct } from "@/app/services/generated/enums/enumSecurityProduct.generated";
import { EnumSessionStatus } from "@/app/services/generated/enums/enumSessionStatus.generated";
import { EnumShopifyOrderTag } from "@/app/services/generated/enums/enumShopifyOrderTag.generated";
import { EnumSmsContext } from "@/app/services/generated/enums/enumSmsContext.generated";
import { EnumSmsStatus } from "@/app/services/generated/enums/enumSmsStatus.generated";
import { EnumSouthAfricanDutyTariff } from "@/app/services/generated/enums/enumSouthAfricanDutyTariff.generated";
import { EnumSpiritDutyExemptionReason } from "@/app/services/generated/enums/enumSpiritDutyExemptionReason.generated";
import { EnumStandardOrder } from "@/app/services/generated/enums/enumStandardOrder.generated";
import { EnumStockAdjustDutyImplication } from "@/app/services/generated/enums/enumStockAdjustDutyImplication.generated";
import { EnumStockAdjustmentStatus } from "@/app/services/generated/enums/enumStockAdjustmentStatus.generated";
import { EnumStockChangeReason } from "@/app/services/generated/enums/enumStockChangeReason.generated";
import { EnumStockItemType } from "@/app/services/generated/enums/enumStockItemType.generated";
import { EnumStockLevelDisplay } from "@/app/services/generated/enums/enumStockLevelDisplay.generated";
import { EnumStockMovementReferenceSource } from "@/app/services/generated/enums/enumStockMovementReferenceSource.generated";
import { EnumStockReductionOption } from "@/app/services/generated/enums/enumStockReductionOption.generated";
import { EnumStockTakeStatus } from "@/app/services/generated/enums/enumStockTakeStatus.generated";
import { EnumStockTransferStatus } from "@/app/services/generated/enums/enumStockTransferStatus.generated";
import { EnumStockUom } from "@/app/services/generated/enums/enumStockUom.generated";
import { EnumStripePaymentMethod } from "@/app/services/generated/enums/enumStripePaymentMethod.generated";
import { EnumSwedishDutyTariff } from "@/app/services/generated/enums/enumSwedishDutyTariff.generated";
import { EnumTaskRepeatBasis } from "@/app/services/generated/enums/enumTaskRepeatBasis.generated";
import { EnumTaskStatus } from "@/app/services/generated/enums/enumTaskStatus.generated";
import { EnumTpPaymentMethod } from "@/app/services/generated/enums/enumTpPaymentMethod.generated";
import { EnumTpProductListSortOption } from "@/app/services/generated/enums/enumTpProductListSortOption.generated";
import { EnumTpSessionErrorReason } from "@/app/services/generated/enums/enumTpSessionErrorReason.generated";
import { EnumTransactionType } from "@/app/services/generated/enums/enumTransactionType.generated";
import { EnumTransportationDistanceUnit } from "@/app/services/generated/enums/enumTransportationDistanceUnit.generated";
import { EnumUkBeerDutySection } from "@/app/services/generated/enums/enumUkBeerDutySection.generated";
import { EnumUkDutyRate } from "@/app/services/generated/enums/enumUkDutyRate.generated";
import { EnumUkDutyReturnType } from "@/app/services/generated/enums/enumUkDutyReturnType.generated";
import { EnumUkNewDutyAbvRange } from "@/app/services/generated/enums/enumUkNewDutyAbvRange.generated";
import { EnumUkNewDutyProductType } from "@/app/services/generated/enums/enumUkNewDutyProductType.generated";
import { EnumUkNewDutyRate } from "@/app/services/generated/enums/enumUkNewDutyRate.generated";
import { EnumUllageReturnMethod } from "@/app/services/generated/enums/enumUllageReturnMethod.generated";
import { EnumUllageStatus } from "@/app/services/generated/enums/enumUllageStatus.generated";
import { EnumUsageType } from "@/app/services/generated/enums/enumUsageType.generated";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { EnumUserTenantGroupLevel } from "@/app/services/generated/enums/enumUserTenantGroupLevel.generated";
import { EnumUserTenantRole } from "@/app/services/generated/enums/enumUserTenantRole.generated";
import { EnumVehicleProfile } from "@/app/services/generated/enums/enumVehicleProfile.generated";
import { EnumVesselAvailability } from "@/app/services/generated/enums/enumVesselAvailability.generated";
import { EnumVesselMainPurpose } from "@/app/services/generated/enums/enumVesselMainPurpose.generated";
import { EnumVesselMaintenancePeriodBasis } from "@/app/services/generated/enums/enumVesselMaintenancePeriodBasis.generated";
import { EnumVesselMovementSourceType } from "@/app/services/generated/enums/enumVesselMovementSourceType.generated";
import { EnumVesselMovementTargetType } from "@/app/services/generated/enums/enumVesselMovementTargetType.generated";
import { EnumVesselStateIcon } from "@/app/services/generated/enums/enumVesselStateIcon.generated";
import { EnumVesselSummaryField } from "@/app/services/generated/enums/enumVesselSummaryField.generated";
import { EnumVesselTypeIcon } from "@/app/services/generated/enums/enumVesselTypeIcon.generated";
import { EnumVolumeUnit } from "@/app/services/generated/enums/enumVolumeUnit.generated";
import { EnumWeightUnit } from "@/app/services/generated/enums/enumWeightUnit.generated";
import { EnumWidgetDragType } from "@/app/services/generated/enums/enumWidgetDragType.generated";
import { EnumWidgetSize } from "@/app/services/generated/enums/enumWidgetSize.generated";
import { EnumYesNoEither } from "@/app/services/generated/enums/enumYesNoEither.generated";

export function getAllGeneratedEnumValues() : readonly BaseEnumType[] {
  const allEnumValues = [
    EnumAccountPostingLineType.getValues(),
    EnumAccountPostingStatus.getValues(),
    EnumAccountsPackageType.getValues(),
    EnumActivityLogType.getValues(),
    EnumAddressLine.getValues(),
    EnumAggregatingOperation.getValues(),
    EnumAiRequestType.getValues(),
    EnumAlcoholType.getValues(),
    EnumAnswerFormat.getValues(),
    EnumAssemblyIngredientSource.getValues(),
    EnumAssemblyOutputTarget.getValues(),
    EnumAssemblyRecipeType.getValues(),
    EnumAssemblyStatus.getValues(),
    EnumAssemblyType.getValues(),
    EnumAustralianAlcoholTariff.getValues(),
    EnumBeerflexOrderConfirmationStatus.getValues(),
    EnumBeerflexOrderType.getValues(),
    EnumBillingPlanStatus.getValues(),
    EnumBmEntityType.getValues(),
    EnumBogofQuantityBasis.getValues(),
    EnumBottleDepositBalanceChangeReason.getValues(),
    EnumBpSessionErrorReason.getValues(),
    EnumBrewmanBarcodeType.getValues(),
    EnumCacheEntityType.getValues(),
    EnumCaseLabelWeightType.getValues(),
    EnumChangeLogLineType.getValues(),
    EnumChangeSection.getValues(),
    EnumChangeType.getValues(),
    EnumColumnType.getValues(),
    EnumConsumableType.getValues(),
    EnumContainerStatus.getValues(),
    EnumCostPriceUpdateType.getValues(),
    EnumCountry.getValues(),
    EnumCreditCalculationType.getValues(),
    EnumCreditType.getValues(),
    EnumCtVirtualNo.getValues(),
    EnumCurrency.getValues(),
    EnumCustomerHappinessRating.getValues(),
    EnumDashboardComponent.getValues(),
    EnumDataImportAction.getValues(),
    EnumDataImportDateFormat.getValues(),
    EnumDataImportTimestampFormat.getValues(),
    EnumDataImportType.getValues(),
    EnumDateFormat.getValues(),
    EnumDateType.getValues(),
    EnumDayOfWeek.getValues(),
    EnumDeliveryNotificationSetting.getValues(),
    EnumDiscountBasis.getValues(),
    EnumDiscountParent.getValues(),
    EnumDiscountTierBasis.getValues(),
    EnumDistributionType.getValues(),
    EnumDocumentContextType.getValues(),
    EnumDocumentEmailTag.getValues(),
    EnumDocumentFileType.getValues(),
    EnumDocumentGenerationOutputFileType.getValues(),
    EnumImageFormat.getValues(),
    EnumDocumentTagType.getValues(),
    EnumDocumentType.getValues(),
    EnumDocumentTypeGroup.getValues(),
    EnumDutyHslsRate.getValues(),
    EnumDutyRateBasis.getValues(),
    EnumDutyScheme.getValues(),
    EnumDutySource.getValues(),
    EnumEcommerceConnectionStatus.getValues(),
    EnumEcommerceOrderOriginType.getValues(),
    EnumEdiSource.getValues(),
    EnumEireAlcoholCategory.getValues(),
    EnumEireDutyRateBand.getValues(),
    EnumEireMovementType.getValues(),
    EnumEmailContext.getValues(),
    EnumEmailDocumentGrouping.getValues(),
    EnumEmailTagSource.getValues(),
    EnumEmailType.getValues(),
    EnumEprMaterialType.getValues(),
    EnumEprPackagingActivity.getValues(),
    EnumEprPackagingClass.getValues(),
    EnumEprPackagingType.getValues(),
    EnumEprProducerStatus.getValues(),
    EnumEprRecyclabilityAssessmentRating.getValues(),
    EnumExportIncotermCode.getValues(),
    EnumExternalCalendarProvider.getValues(),
    EnumExternalOrderStatus.getValues(),
    EnumFeatureFlag.getValues(),
    EnumFileType.getValues(),
    EnumFilteringOperation.getValues(),
    EnumGermanBeerDutyMovementType.getValues(),
    EnumGermanBeerDutyProductType.getValues(),
    EnumGermanBeerDutyReturnCellProductType.getValues(),
    EnumGetUserByCredentialStatus.getValues(),
    EnumGroupingOperation.getValues(),
    EnumHistoryDateRangePick.getValues(),
    EnumIntegrationType.getValues(),
    EnumInvoicesOrCredits.getValues(),
    EnumItemMainPurpose.getValues(),
    EnumJourneyLabelStatus.getValues(),
    EnumJourneyStopPlanningStatus.getValues(),
    EnumKegstarContainerType.getValues(),
    EnumLeadStatus.getValues(),
    EnumLocationBondedStatus.getValues(),
    EnumMetricType.getValues(),
    EnumNatureOfTransactionCode.getValues(),
    EnumEmailNotificationType.getValues(),
    EnumNumberingType.getValues(),
    EnumOneFreePeriod.getValues(),
    EnumOrderSortBy.getValues(),
    EnumOrderSource.getValues(),
    EnumOrderStatus.getValues(),
    EnumOutletRatingExclusions.getValues(),
    EnumPackageTypeCategoryType.getValues(),
    EnumPalletStatus.getValues(),
    EnumPlannedStockAction.getValues(),
    EnumPlannedStockFollowUpAction.getValues(),
    EnumPlannedStockStatus.getValues(),
    EnumPriceListGroupSortBy.getValues(),
    EnumPriceListLineSortBy.getValues(),
    EnumPriceListSubGroup.getValues(),
    EnumPrinterPreference.getValues(),
    EnumProcessIngredientSource.getValues(),
    EnumProcessOutputTarget.getValues(),
    EnumPurchaseOrderDeliveryDisbursement.getValues(),
    EnumPurchaseOrderDeliveryStatus.getValues(),
    EnumPurchaseOrderStatus.getValues(),
    EnumQcProbeProvider.getValues(),
    EnumQueuedJobType.getValues(),
    EnumRecurringJobType.getValues(),
    EnumReportBuilder.getValues(),
    EnumRetailPaymentMethod.getValues(),
    EnumSalesTextType.getValues(),
    EnumSalesVisitAssociatedEntityType.getValues(),
    EnumScannerInputType.getValues(),
    EnumScannerType.getValues(),
    EnumSecurityProduct.getValues(),
    EnumSessionStatus.getValues(),
    EnumShopifyOrderTag.getValues(),
    EnumSmsContext.getValues(),
    EnumSmsStatus.getValues(),
    EnumSouthAfricanDutyTariff.getValues(),
    EnumSpiritDutyExemptionReason.getValues(),
    EnumStandardOrder.getValues(),
    EnumStockAdjustDutyImplication.getValues(),
    EnumStockAdjustmentStatus.getValues(),
    EnumStockChangeReason.getValues(),
    EnumStockItemType.getValues(),
    EnumStockLevelDisplay.getValues(),
    EnumStockMovementReferenceSource.getValues(),
    EnumStockReductionOption.getValues(),
    EnumStockTakeStatus.getValues(),
    EnumStockTransferStatus.getValues(),
    EnumStockUom.getValues(),
    EnumStripePaymentMethod.getValues(),
    EnumSwedishDutyTariff.getValues(),
    EnumTaskRepeatBasis.getValues(),
    EnumTaskStatus.getValues(),
    EnumTpPaymentMethod.getValues(),
    EnumTpProductListSortOption.getValues(),
    EnumTpSessionErrorReason.getValues(),
    EnumTransactionType.getValues(),
    EnumTransportationDistanceUnit.getValues(),
    EnumUkBeerDutySection.getValues(),
    EnumUkDutyRate.getValues(),
    EnumUkDutyReturnType.getValues(),
    EnumUkNewDutyAbvRange.getValues(),
    EnumUkNewDutyProductType.getValues(),
    EnumUkNewDutyRate.getValues(),
    EnumUllageReturnMethod.getValues(),
    EnumUllageStatus.getValues(),
    EnumUsageType.getValues(),
    EnumUserPermission.getValues(),
    EnumUserTenantGroupLevel.getValues(),
    EnumUserTenantRole.getValues(),
    EnumVehicleProfile.getValues(),
    EnumVesselAvailability.getValues(),
    EnumVesselMainPurpose.getValues(),
    EnumVesselMaintenancePeriodBasis.getValues(),
    EnumVesselMovementSourceType.getValues(),
    EnumVesselMovementTargetType.getValues(),
    EnumVesselStateIcon.getValues(),
    EnumVesselSummaryField.getValues(),
    EnumVesselTypeIcon.getValues(),
    EnumVolumeUnit.getValues(),
    EnumWeightUnit.getValues(),
    EnumWidgetDragType.getValues(),
    EnumWidgetSize.getValues(),
    EnumYesNoEither.getValues(),
  ].flat();

  return allEnumValues;
}
